export default {
    "welcome": {
        "title": "Willkommen bei ProcrastiQ",
        "subtitle": "Dein Produktivit?tsgef?hrte",
        "modal": {
            "title": "Willkommen bei ProcrastiQ",
            "headline": "Kluge Pausen f?r dein Gehirn",
            "subheading": "Gehirnsnacks, Fakten und achtsame Momente, die freie Minuten in etwas Sinnvolles verwandeln. ",
            "text": "Procrastiq wird Prokrastination zu etwas Sinnvollem. Anstatt endlos durch soziale Medien zu scrollen, entdecken Sie schnelle Gehirnsnacks, die dazu dienen, Ihren Geist zu unterhalten, Ihren Geist anzuregen und Ihnen vielleicht sogar etwas Neues beizubringen. \n\nEs geht hier nicht um Produktivit?t um jeden Preis. Jeder braucht einen Moment zum Pause, Auftanken und Abstand von der Arbeit. Procrastiq hilft dir, diese kleinen Pausen in etwas Positives zu verwandeln ? gef?llt mit Neugier, Freude und t?glichem Gehirntraining. Kleine Herausforderungen. Gro?er Fortschritt. ",
            "cta": "Los geht's"
        }
    },
    "login": {
        "title": "Anmelden",
        "email": "E-Mail",
        "password": "Passwort",
        "submit": "Anmelden",
        "cancel": "Abbrechen",
        "success": "Anmeldung erfolgreich",
        "lead": "Willkommen zur?ck ? nimm deine Serie auf und steige in den Ligen auf. "
    },
    "logout": "Ausloggen",
    "logo": {
        "title": "ProcrastiQ",
        "slogan": "Kluge Pausen f?r dein Gehirn"
    },
    "register": {
        "title": "Registrieren",
        "name": "Name",
        "email": "E-Mail",
        "password": "Passwort",
        "submit": "Konto erstellen",
        "cancel": "Abbrechen",
        "success": "Erfolgreiche Registrierung",
        "country": "Land",
        "lead": "Erstelle ein Konto, um XP zu verdienen, R?nge freizuschalten und w?chentlichen Ligen beizutreten. "
    },
    "social": {
        "divider": "Oder mach weiter mit",
        "signInWith": "Melden Sie sich bei {{provider}}",
        "continueWith": "Mach weiter mit {{provider}}",
        "failed": "Die soziale Anmeldung scheiterte",
        "popup_blocked": "Das Popup wurde blockiert. Bitte erlauben Sie Popups und versuchen Sie es erneut. ",
        "cancelled": "Die Anmeldung wurde abgesagt. "
    },
    "common": {
        "cancel": "Abbrechen",
        "saving": "Retten... ",
        "unknown_error": "Unbekannter Fehler",
        "select_country": "Land ausw?hlen",
        "select_option": "W?hlen Sie eine Option",
        "country": "Land"
    },
    "language": {
        "page_language": "Seitensprache",
        "switch_to": "Wechsle zu {{language}}"
    },
    "cookies": {
        "title": "Cookies",
        "message": "Wir verwenden Cookies f?r Analysen (Google Analytics), um Procrastiq zu verbessern.",
        "privacy_link": "Datenschutzrichtlinie",
        "accept": "Akzeptieren",
        "reject": "Ablehnen"
    },
    "footer": {
        "columns": {
            "about": {
                "title": "?ber uns",
                "mission": "Mission",
                "progression": "XP, Level & Ligen",
                "creator_progression": "Sch?pfer-XP & R?nge",
                "contact": "Kontaktieren Sie uns"
            },
            "leaderboards": {
                "title": "Bestenlisten",
                "players": "Mitglieder",
                "creators": "Mitwirkende"
            },
            "legal": {
                "title": "Datenschutz & Bedingungen",
                "community": "Gemeinschaftsrichtlinien",
                "terms": "Nutzungsbedingungen",
                "privacy": "Datenschutzrichtlinie"
            },
            "social": {
                "title": "Soziales",
                "facebook": "Facebook",
                "instagram": "Instagram"
            }
        }
    },
    "pages": {
        "mission": {
            "title": "Mission",
            "content": "ProcrastiQ verwandelt kleine Pausen in bedeutungsvolle Momente ? Gehirnsnacks, R?tsel und achtsame Pausen, die Ihren Geist unterhalten und stimulieren.\n\nWir glauben, dass Aufschieben keine verschwendete Zeit sein muss. Jeder verdient einen Moment zum Auftanken, und wir helfen, diese Momente positiv, neugierig und unterhaltsam zu gestalten."
        },
        "contact": {
            "title": "Kontaktieren Sie uns",
            "content": "Haben Sie eine Frage, eine Idee zur Verbesserung oder ist Ihnen etwas aufgefallen, das nicht so funktioniert, wie es sollte? Melden Sie sich bei uns ? jedes Feedback hilft uns, Procrastiq weiter zu verbessern.\n\nSchreiben Sie uns an:\n\nhello@procrastiq.com\n\nWir freuen uns auch ?ber Ihre Vorschl?ge zu neuen Inhalten, Funktionen oder Themen, die Sie auf Procrastiq sehen m?chten."
        },
        "community": {
            "title": "Community-Richtlinien",
            "content": "ProcrastiQ ist ein einladender Raum f?r neugierige K?pfe. Seien Sie respektvoll, freundlich und konstruktiv in Ihren Interaktionen.\n\nPosten Sie keine sch?dlichen, beleidigenden oder Spam-Inhalte. Melden Sie alles, was nicht dazugeh?rt. Gemeinsam halten wir dies zu einem positiven Ort zum Lernen und f?r clevere Pausen."
        },
        "terms": {
            "title": "Nutzungsbedingungen",
            "content": "**Zuletzt aktualisiert: 7. September 2026**\n\nMit der Nutzung des Dienstes Procrastiq stimmen Sie diesen Bedingungen zu. Wenn Sie nicht einverstanden sind, nutzen Sie den Dienst bitte nicht.\n\n## 1. ?ber Procrastiq\n\nProcrastiq ist eine Online-Plattform f?r Lernen, Quiz, R?tsel und andere interaktive Inhalte.\n\nDie Inhalte des Dienstes dienen vor allem der Bildung und Unterhaltung. Sie stellen keine fachliche, rechtliche, medizinische, finanzielle oder sonstige professionelle Beratung dar.\n\n## 2. Benutzerkonto\n\nEinige Funktionen von Procrastiq k?nnen die Erstellung eines Benutzerkontos erfordern.\n\nSie sind f?r die Richtigkeit der Angaben in Ihrem Konto und f?r die Sicherung Ihrer Zugangsdaten verantwortlich.\n\nEin Konto darf nicht dazu verwendet werden, Rechte anderer Personen, geltende Gesetze oder diese Bedingungen zu verletzen.\n\n## 3. Nutzungsregeln\n\nBei der Nutzung von Procrastiq ist es insbesondere nicht gestattet:\n\n* rechtswidrige, betr?gerische, hasserf?llte oder anderweitig sch?dliche Inhalte zu ver?ffentlichen,\n* Urheberrechte oder andere Rechte Dritter zu verletzen,\n* andere Nutzer zu bel?stigen,\n* die Sicherheit oder den Betrieb des Dienstes zu st?ren,\n* Inhalte oder Daten automatisiert auf von uns nicht erlaubte Weise abzurufen,\n* Bewertungen, XP, Bestenlisten oder andere Spielmechaniken zu missbrauchen.\n\n## 4. Nutzerinhalte\n\nNutzer k?nnen eigene Inhalte erstellen oder einreichen, zum Beispiel Quizze, Fragen, Kommentare oder andere Beitr?ge.\n\nMit dem Einreichen von Inhalten best?tigen Sie, dass Sie das Recht haben, sie zu ver?ffentlichen.\n\nIhre Rechte an Ihren Inhalten bleiben bestehen. Gleichzeitig r?umen Sie uns ein nicht ausschlie?liches Recht ein, diese Inhalte im f?r den Betrieb von Procrastiq erforderlichen Umfang zu speichern, anzuzeigen, technisch anzupassen und bereitzustellen.\n\n## 5. Inhaltsmoderation\n\nWir k?nnen Nutzerinhalte pr?fen und bei Verst??en gegen diese Bedingungen oder geltendes Recht ablehnen, ausblenden oder entfernen.\n\nIn schweren oder wiederholten F?llen k?nnen wir ein Benutzerkonto einschr?nken oder k?ndigen.\n\nSoweit die Umst?nde es zulassen und das Recht es verlangt, informieren wir den Nutzer ?ber den Grund einer solchen Entscheidung.\n\n## 6. Inhalte von Procrastiq\n\nDirekt von Procrastiq ver?ffentlichte Inhalte k?nnen Fehler oder Ungenauigkeiten enthalten. Obwohl wir Informationen pr?fen und fortlaufend verbessern wollen, k?nnen wir Vollst?ndigkeit oder Fehlerfreiheit nicht garantieren.\n\nQuizze und andere Bildungsinhalte haben vor allem informativen und unterhaltsamen Charakter.\n\n## 7. Verf?gbarkeit des Dienstes\n\nWir bem?hen uns, Procrastiq verf?gbar und funktionsf?hig zu halten, k?nnen jedoch keinen ununterbrochenen oder fehlerfreien Betrieb garantieren.\n\nWir k?nnen den Dienst im Laufe der Zeit ?ndern, erweitern oder Teile davon einstellen.\n\n## 8. Haftung\n\nSoweit nach geltendem Recht zul?ssig, haften wir nicht f?r Sch?den, die durch unsachgem??e Nutzung des Dienstes oder durch Vertrauen auf rein informative oder bildende Inhalte entstehen.\n\nDies ber?hrt nicht Rechte von Nutzern, die nach geltendem Recht nicht eingeschr?nkt werden d?rfen.\n\n## 9. Datenschutz\n\nInformationen zur Verarbeitung personenbezogener Daten finden Sie in unserer [Datenschutzerkl?rung](/legal/privacy).\n\n## 10. ?nderungen dieser Bedingungen\n\nWir k?nnen diese Bedingungen von Zeit zu Zeit aktualisieren, etwa wegen ?nderungen am Dienst, an Rechtsvorschriften oder an der Funktionsweise von Procrastiq.\n\nDas Datum der letzten Aktualisierung steht stets oben auf dieser Seite. ?ber wesentliche ?nderungen k?nnen wir Nutzer auch ?ber den Dienst oder per E-Mail informieren.\n\n## 11. Kontakt\n\nFragen zu diesen Bedingungen richten Sie bitte an:\n\n[hello@procrastiq.com](mailto:hello@procrastiq.com)"
        },
        "privacy": {
            "title": "Datenschutzrichtlinie",
            "content": "**Zuletzt aktualisiert: 7. September 2026**\n\nWir nehmen Ihre Privatsph?re ernst. Nachfolgend erl?utern wir, welche personenbezogenen Daten wir bei der Nutzung von Procrastiq verarbeiten, warum wir sie ben?tigen und welche Rechte Sie haben.\n\n## 1. Wer die Daten verarbeitet\n\nVerantwortlicher f?r die personenbezogenen Daten ist:\n\n**Michal Orl?k**\nnat?rliche Person\n\nKontakt f?r Fragen zum Datenschutz:\n\n**[hello@procrastiq.com](mailto:hello@procrastiq.com)**\n\n## 2. Welche Daten wir verarbeiten\n\nJe nachdem, wie Sie Procrastiq nutzen, k?nnen wir insbesondere verarbeiten:\n\n* Kontodaten, zum Beispiel Name, Benutzername und E-Mail-Adresse,\n* Daten, die bei der Anmeldung ?ber einen externen Dienst, zum Beispiel Google, erhoben werden,\n* Informationen zur Nutzung des Dienstes, zum Beispiel angezeigte Inhalte, Quiz-Ergebnisse, erhaltene XP, Streaks, Reaktionen, Lesezeichen und Feed-Aktivit?t,\n* Inhalte, die Sie selbst erstellen oder ?bermitteln,\n* technische Daten, zum Beispiel IP-Adresse, Ger?tetyp, Browser sowie Informationen, die f?r Sicherheit und ordnungsgem??en Betrieb des Dienstes erforderlich sind.\n\n## 3. Warum wir die Daten verwenden\n\nWir verwenden personenbezogene Daten insbesondere, um:\n\n* Ihr Konto zu erstellen und zu verwalten,\n* Procrastiq-Funktionen bereitzustellen,\n* Ihren Fortschritt, Ergebnisse, XP und weitere Aktivit?t zu speichern,\n* Inhalte und Empfehlungen zu personalisieren,\n* den Dienst vor Missbrauch zu sch?tzen,\n* Fehler und technische Probleme zu beheben,\n* mit Ihnen zu kommunizieren,\n* die Funktionsweise des Dienstes zu analysieren und zu verbessern.\n\n## 4. Rechtsgrundlage der Verarbeitung\n\nWir verarbeiten Daten je nach Zweck insbesondere:\n\n* weil sie f?r die Bereitstellung des Dienstes erforderlich sind,\n* auf Grundlage unseres berechtigten Interesses an der Sicherung und Verbesserung von Procrastiq,\n* auf Grundlage Ihrer Einwilligung, soweit eine Einwilligung erforderlich ist,\n* gegebenenfalls zur Erf?llung rechtlicher Verpflichtungen.\n\nBeruht die Verarbeitung auf einer Einwilligung, k?nnen Sie diese jederzeit widerrufen.\n\n## 5. An wen Daten weitergegeben werden k?nnen\n\nWir verkaufen Ihre personenbezogenen Daten nicht.\n\nF?r den Betrieb des Dienstes k?nnen wir jedoch externe Anbieter nutzen, zum Beispiel f?r:\n\n* Hosting und Infrastruktur,\n* Benutzeranmeldung,\n* Versand von E-Mails und Benachrichtigungen,\n* Analytik und Fehlerdiagnose.\n\nDiese Anbieter d?rfen Daten nur in dem Umfang verarbeiten, der zur Erbringung ihrer Leistungen erforderlich ist.\n\n## 6. Wie lange wir Daten aufbewahren\n\nMit Ihrem Konto verbundene Daten bewahren wir in der Regel f?r die Dauer des Kontos und anschlie?end so lange auf, wie es zur Erf?llung rechtlicher Verpflichtungen oder zum Schutz unserer berechtigten Interessen erforderlich ist.\n\nTechnische und analytische Daten bewahren wir nur so lange auf, wie es f?r ihren Zweck erforderlich ist.\n\n## 7. Ihre Rechte\n\nIm Zusammenhang mit der Verarbeitung personenbezogener Daten haben Sie unter Umst?nden das Recht:\n\n* Informationen dar?ber zu erhalten, welche Daten wir ?ber Sie verarbeiten,\n* die Berichtigung unrichtiger Daten zu verlangen,\n* die L?schung von Daten zu verlangen,\n* die Einschr?nkung der Verarbeitung zu verlangen,\n* Widerspruch gegen bestimmte Verarbeitungsweisen einzulegen,\n* Ihre Daten in einem ?bertragbaren Format zu erhalten,\n* eine erteilte Einwilligung zu widerrufen.\n\nEine Anfrage k?nnen Sie senden an:\n\n**[hello@procrastiq.com](mailto:hello@procrastiq.com)**\n\nAuf Anfragen antworten wir im Einklang mit den geltenden Rechtsvorschriften.\n\n## 8. Kontol?schung\n\nWenn der Dienst die L?schung des Kontos erm?glicht, k?nnen Sie die Entfernung direkt in den Kontoeinstellungen beantragen oder uns unter **[hello@procrastiq.com](mailto:hello@procrastiq.com)** kontaktieren.\n\nMit der L?schung des Kontos entfernen oder anonymisieren wir personenbezogene Daten, die wir aus rechtlichen oder Sicherheitsgr?nden nicht mehr aufbewahren m?ssen.\n\n## 9. Cookies und ?hnliche Technologien\n\nProcrastiq kann Cookies und ?hnliche Technologien verwenden, die f?r Anmeldung, Sicherheit, Speicherung von Einstellungen und gegebenenfalls Analytik erforderlich sind.\n\nAusf?hrlichere Informationen zu Cookies k?nnen in einer gesonderten Cookie-Richtlinie enthalten sein.\n\n## 10. Sicherheit\n\nWir treffen angemessene technische und organisatorische Ma?nahmen zum Schutz personenbezogener Daten vor unbefugtem Zugriff, Verlust oder Missbrauch.\n\nKein System kann jedoch als absolut sicher gelten.\n\n## 11. Beschwerde\n\nWenn Sie der Ansicht sind, dass wir Ihre personenbezogenen Daten rechtswidrig verarbeiten, k?nnen Sie sich auch an die zust?ndige Aufsichtsbeh?rde wenden.\n\nIn der Tschechischen Republik ist dies das **Amt f?r den Schutz personenbezogener Daten (??ad pro ochranu osobn?ch ?daj?)**.\n\n## 12. ?nderungen dieser Richtlinie\n\nWir k?nnen diese Richtlinie von Zeit zu Zeit aktualisieren, zum Beispiel im Zusammenhang mit neuen Funktionen oder ?nderungen der Rechtsvorschriften.\n\nDas Datum der letzten Aktualisierung geben wir stets am Anfang dieser Seite an."
        },
        "progression": {
            "title": "XP, Level & Ligen",
            "content": "ProcrastiQ belohnt Neugier. Beantworten Sie Quizfragen, bauen Sie Serien auf und steigen Sie von gelegentlichen Gehirnsnacks bis zu w?chentlichen Wettbewerben auf.\n\n## Erfahrungspunkte (XP)\n\nSie verdienen dauerhafte XP, wenn Sie gut spielen ? zum Beispiel durch richtige Antworten, Bonuspunkte beim ersten Versuch, schwierigere Fragen, Wiederholungen und t?gliche Ziele. Dauerhafte XP setzen sich nie zur?ck und z?hlen immer f?r Ihr Level.\n\nEs gibt auch Ranglisten-XP, die nur f?r w?chentliche Ligen verwendet werden. Ranglisten-XP nutzen t?gliche abnehmende Ertr?ge: Fr?he XP am Tag z?hlen voll, sp?tere Gewinne weniger. Das h?lt den Wettbewerb fair, wenn jemand den ganzen Tag spielt.\n\n## Level\n\nIhr Level ergibt sich aus den gesamten dauerhaften XP. Jedes Level ben?tigt etwas mehr XP als das vorherige (eine wachsende Kurve), sodass der Fortschritt stets bedeutungsvoll bleibt.\n\nDein Profil zeigt, wie viel XP du im aktuellen Level hast und wie viel du f?r das n?chste brauchst. \n\n## Titelr?nge\n\nR?nge sind Titel, die je nach Level freigeschaltet werden. Sie sind ein Abzeichen daf?r, wie weit du gekommen bist ? getrennt von den w?chentlichen Ligastufen. \n\n- Stufe 1 ? Neugieriger Geist\n- Stufe 3 ? Entdecker\n- Stufe 5 ? Forscher\n- Stufe 8 ? Probleml?ser\n- Stufe 12 ? Analyst\n- Stufe 18 ? Logiker\n- Level 25 ? Stratege\n- Stufe 35 ? Polymath\n- Level 50 ? Genie\n- Level 70 ? Master of Knowledge\n- Level 100 ? Procrastiq Legende\n\n## W?chentliche Ligen\n\nLigen sind ein w?chentlicher Wettbewerb mit anderen Spielern in Gruppen von etwa 20 Personen. \n\nStufen vom niedrigsten bis zum h?chsten: \n\n- Eisen\n- Bronze\n- Silber\n- Gold\n- Platin\n- Diamant\n- Meister\n- Legend?r\n\nJede Woche trittst du innerhalb deiner Gruppe auf Ranglisten-XP an. Am Ende der Woche steigen ungef?hr die besten Spieler eine Stufe auf und die schlechtesten auf eine Stufe ab. Alle anderen bleiben. \n\nSie warten nicht auf einen Reset am Montag, um beizutreten. Wenn Sie berechtigt sind, werden Sie sofort in eine offene Gruppe eingeteilt ? oder eine neue Gruppe wird f?r Sie erstellt. \n\nUm Ligen freizuschalten, brauchst du in der Regel: \n\n- mindestens 100 permanente XP\n- mindestens 10 abgeschlossene Aktivit?ten\n- Aktivit?t an mindestens 2 verschiedenen Tagen\n- Bestenlisten-Sichtbarkeit aktiviert f?r dein Profil\n\n?ffne jederzeit die Bestenliste oder dein Statistik-Panel, um deine Ebene, Position und Gruppe zu sehen. "
        },
        "creator_progression": {
            "title": "Sch?pfer-XP & R?nge",
            "content": "Das Erstellen von Inhalten auf ProcrastiQ hat seinen eigenen Fortschritt ? v?llig getrennt von Spieler-XP, Levels und w?chentlichen Ligen. \n\nWenn Leute deine Quizze und Gehirnsnacks genie?en, erh?ltst du Creator-XP (CXP). CXP schaltet die Creator-R?nge frei und setzt dich auf die Contributors-Bestenlisten. \n\n## Zwei unabh?ngige Systeme\n\n- Spielerfortschritt ? XP aus dem Spiel, Levels, Titelr?nge, w?chentliche Ligen\n- Creator-Progression ? CXP von qualitativ hochwertigen Inhalten, Creator-R?ngen, Contributors-Boards\n\nDas Spielen erh?ht nicht deinen Creator-Rang. Das Erstellen erh?ht nicht dein Spielerlevel. Du kannst in beiden Tracks gleichzeitig wachsen. \n\n## Wie du Sch?pfer-XP erh?ltst\n\nCXP wird f?r genehmigte Beitr?ge und f?r das Engagement bei diesen Inhalten vergeben ? nicht f?r die Anzahl der Entw?rfe, die man einreicht.\n\nTypische Belohnungen:\n\n- Genehmigter Inhalt ? +20 CXP (einmal pro Artikel)\n- Alle 10 abgeschlossenen Aufgaben bei deinem Inhalt ? +2 CXP\n- Alle 10 Likes auf deinem Inhalt ? +5 CXP\n- Alle 10 Lesezeichen auf deinem Inhalt ? +2 CXP\n\nAufrufe und andere Statistiken werden in deinem Creator-Profil verfolgt, aber nur die oben genannten Belohnungen gew?hren CXP. Werte k?nnen im Laufe der Zeit angepasst werden.\n\n## Creator-R?nge\n\nDein Creator-Rang ergibt sich aus der gesamten CXP. Die Schwellenwerte steigen ungef?hr exponentiell, sodass fr?he Fortschritte schnell erscheinen und h?here R?nge weiterhin bedeutsam bleiben.\n\n- 0 CXP ? Mitwirkender\n- 50 CXP ? Creator\n- 150 CXP ? Autor\n- 400 CXP ? Experte\n- 1.000 CXP ? Mentor\n- 2.500 CXP ? Meister-Creator\n- 6.000 CXP ? Procrastiq Weise\n\nDein Profil zeigt deinen aktuellen Rang, CXP und den Fortschritt zum n?chsten Rang an.\n\n## Bestenlisten der Mitwirkenden\n\nCreator werden nach Creator XP und nicht nach der Anzahl der Einsendungen bewertet.\n\n- W?chentlich ? in dieser Woche verdiente CXP\n- Monatlich ? in diesem Monat verdiente CXP\n- Gesamt ? gesamte CXP\n\n?ffne die Bestenlisten und wechsle zu Mitwirkenden, um zu sehen, wer steigt."
        }
    },
    "account": {
        "profile_picture": "Profilbild",
        "save_changes": "?nderungen speichern",
        "update_success": "Profil erfolgreich aktualisiert",
        "update_failed": "Profilaktualisierung fehlgeschlagen",
        "country": "Land",
        "avatar": {
            "upload_label": "Avatar hochladen",
            "upload_success": "Avatar erfolgreich hochgeladen",
            "upload_failed": "Avatar-Upload fehlgeschlagen",
            "delete_confirm": "Bist du sicher, dass du deinen Avatar l?schen m?chtest?",
            "delete_success": "Avatar erfolgreich gel?scht",
            "delete_failed": "L?schen des Avatars fehlgeschlagen"
        },
        "password": {
            "set_optional": "Passwort festlegen (optional)",
            "change_optional": "Passwort ?ndern (optional)",
            "oauth_info": "Du hast dich mit {{method}} angemeldet. Du kannst optional ein Passwort festlegen, um die Anmeldung per E-Mail/Passwort zu erm?glichen.",
            "current": "Aktuelles Passwort",
            "current_placeholder": "Gib das aktuelle Passwort ein",
            "current_required": "Das aktuelle Passwort wird ben?tigt, um das Passwort zu ?ndern",
            "new": "Neues Passwort",
            "set_placeholder": "Passwort festlegen",
            "leave_blank_placeholder": "Leer lassen, um das aktuelle beizubehalten",
            "confirm": "Neues Passwort best?tigen",
            "confirm_placeholder": "Neues Passwort best?tigen",
            "mismatch": "Neue Passw?rter stimmen nicht ?berein"
        }
    },
    "play": {
        "label": "Play",
        "games": {
            "memory": "Memory",
            "focus": "Fokus",
            "sequence": "Sequenz",
            "reflex": "Reflex"
        },
        "memory": {
            "hint_preview": "Merke dir die markierten Felder.",
            "hint_input": "Tippe die Felder an, die du dir gemerkt hast.",
            "cell": "Feld {{n}}"
        },
        "focus": {
            "hint": "Finde das andere Symbol."
        },
        "sequence": {
            "title": "Merke dir die Sequenz",
            "countdown_hint": "Bereit machen — die Sequenz startet gleich.",
            "go": "Los!",
            "hint_watch": "Schau genau hin.",
            "hint_input": "Wiederhole jetzt die Sequenz."
        },
        "reflex": {
            "hint": "Waehle die Farbe, nicht das Wort.",
            "progress": "{{current}} / {{total}}"
        },
        "colors": {
            "red": "ROT",
            "blue": "BLAU",
            "green": "GRUEN",
            "orange": "ORANGE"
        },
        "result": {
            "success": "Super!",
            "fail": "✗ Falsch."
        }
    },

    "pause": {
        "label": "Pause",
        "types": {
            "breathing": "Atmung",
            "eyes": "Augenpause",
            "stretch": "Kurzer Stretch",
            "grounding": "Reset"
        },
        "skip": "Ueberspringen",
        "continue": "Weiter",
        "breathing": {
            "inhale": "Einatmen",
            "exhale": "Ausatmen"
        },
        "eyes": {
            "step_far": "Schau auf etwas weiter weg vom Bildschirm.",
            "step_blink": "Entspanne deine Augen und blinzle langsam mehrmals.",
            "step_close": "Schliesse kurz die Augen."
        },
        "stretch": {
            "step_shoulders": "Lass die Schultern sinken und entspanne sie.",
            "step_sit": "Setz dich etwas aufrechter und entspanne den Ruecken.",
            "step_roll": "Kreise langsam mit den Schultern."
        },
        "grounding": {
            "prompt_color": "Finde 3 Dinge um dich herum mit derselben Farbe.",
            "prompt_sounds": "Nimm 2 verschiedene Geraeusche um dich herum wahr.",
            "prompt_look_away": "Schau fuer ein paar Sekunden vom Bildschirm weg.",
            "prompt_texture": "Beruehre etwas in der Naehe und spuere die Textur.",
            "prompt_breath": "Nimm einen langsamen Atemzug und spuere deine Fuesse.",
            "prompt_feet": "Druecke die Fuesse sanft in den Boden und spuere den Kontakt."
        },
        "result": {
            "done": "Fertig"
        }
    },

    "content": {
        "loading": "Laden...",
        "no_content": "Noch keine Inhalte.",
        "feed_exhausted_tag": "Du hast schon alles zu diesem Tag beantwortet",
        "feed_exhausted_category": "Du hast schon alles zu dieser Kategorie beantwortet",
        "browse_feed": "Inhalt-Feed durchsuchen",
        "back_to_feed": "? Zur?ck zum Feed",
        "back": "? Zur?ck",
        "content_not_found": "Inhalt nicht gefunden",
        "failed_load": "Inhalt wurde nicht geladen",
        "failed_load_more": "Nicht mehr geladen",
        "list": {
            "showing": "Zeigt {{count}} von {{total}}",
            "load_more": "Mehr laden"
        },
        "answer": {
            "your_answer": "Deine Antwort... ",
            "your_result_or_answer": "Ihr Ergebnis oder Ihre Antwort... ",
            "select_or_type": "W?hlen Sie Ihre Antwort... ",
            "fill_in_blank": "F?ll die L?cke aus... ",
            "your_answer_flip": "Deine Antwort (oder ?berpr?fe)... ",
            "reveal_answer": "Enth?lle der Antwort",
            "self_check_prompt": "Wusstest du das? ",
            "knew_it": "Ich wusste es",
            "need_practice": "Brauche mehr ?bung",
            "check": "Check",
            "completed": "Abgeschlossen",
            "completing": "Retten... ",
            "skip": "?berspringen",
            "next": "Als N?chstes",
            "checking": "?berpr?fen... ",
            "correct": "? Richtig! ",
            "not_quite": "? Nicht ganz. ",
            "correct_answer": "Richtige Antwort: {{answer}}"
        },
        "stats": {
            "sign_in_to_react": "Melden Sie sich an, um es zu m?gen oder nicht zu m?gen",
            "bookmark": "Lesezeichen",
            "remove_bookmark": "Bookmark entfernen",
            "save_for_later": "F?r sp?ter aufheben",
            "saved": "Gerettet",
            "share": "Teilen",
            "link_copied": "Link auf Klemmbrett kopiert",
            "share_failed": "Dieses Quiz konnte ich nicht teilen",
            "completions": "Abschl?sse: {{count}}",
            "aria_like": "So wie",
            "aria_dislike": "Abneigung"
        },
        "admin": {
            "edit": "Bearbeiten",
            "delete": "L?schen",
            "stats": "Statistik",
            "stats_title": "Inhaltsstatistik",
            "delete_confirm": "?{{title}}? l?schen?",
            "deleted": "Inhalt gel?scht",
            "delete_failed": "Inhalt konnte nicht gel?scht werden",
            "load_failed": "Inhalt konnte nicht geladen werden",
            "id": "ID",
            "slug": "Slug",
            "status": "Status",
            "locale": "Sprache",
            "likes": "Likes",
            "dislikes": "Dislikes",
            "completions": "Abschl?sse",
            "open_in_admin": "In Admin ?ffnen"
        },
        "difficulty": {
            "label": "Schwierigkeit: {{value}}/{{max}}",
            "value": "{{value}}/{{max}}",
            "aria": "Schwierigkeit {{value}} aus {{max}}"
        },
        "detail": {
            "sign_in_to_answer": "Melden Sie sich an, um diese Frage zu beantworten. ",
            "duration": "Dauer: {{minutes}} min",
            "phase": "Phase {{number}}"
        },
        "list_item": {
            "completions": "{{count}} Fertigstellungen",
            "completions_label": "Abschl?sse: {{count}}"
        },
        "feed": {
            "success": "Richtig! ??",
            "skip": "?berspringen",
            "next": "Als N?chstes",
            "intro_gate": {
                "title": "Melde dich an, um weiterzumachen",
                "body": "Melde dich an oder erstelle ein Konto, und Procrastiq passt sich dem an, was dir Spaß macht.",
                "body_more": "Es wiederholt nicht unnötig dieselben Fragen, merkt sich deine Ergebnisse und bietet Inhalte nach deinen Interessen.",
                "perks": "Außerdem erhältst du Zugang zu XP, Ligen, Survival, Challenges mit anderen Spielern und weiteren Funktionen.",
                "register": "Konto erstellen",
                "login": "Anmelden"
            }
        }
    },
    "categories": {
        "title": "Kategorien",
        "filter": "Filter nach Kategorie",
        "all": "Alle",
        "loading": "Laden von Kategorien... ",
        "empty": "Keine Kategorien",
        "expand": "Unterkategorien erweitern",
        "collapse": "Kollaps-Unterkategorien"
    },
    "tags": {
        "title": "Tags",
        "all": "Alle",
        "loading": "Tags werden geladen... ",
        "empty": "Keine Tags"
    },
    "bookmarks": {
        "title": "Gespeicherte Lesezeichen",
        "empty": "Noch keine gespeicherten Inhalte. "
    },
    "contribute": {
        "title": "Beitrag leisten",
        "subtitle": "Reichen Sie Quizze zur ?berpr?fung ein. Nach der Genehmigung erscheinen sie im Feed. ",
        "subtitle_reliable": "Du bist ein zuverl?ssiger Beitragender ? deine Quizze gehen sofort online. ",
        "add": "+ Quiz abreichen",
        "add_first": "Reichen Sie Ihr erstes Quiz ein",
        "empty": "Du hast noch keinen Inhalt eingereicht. ",
        "load_failed": "Ich habe deine Inhalte nicht geladen",
        "cannot_edit_approved": "Genehmigte Inhalte k?nnen nur von einem Administrator ge?ndert werden. ",
        "delete_confirm": "\"{{title}}\" l?schen? ",
        "deleted": "Inhalt gel?scht",
        "delete_failed": "Inhalt wurde nicht gel?scht",
        "edit": "Bearbeitung",
        "delete": "L?schen",
        "form": {
            "submit_title": "Reichen Sie ein Quiz ein",
            "edit_title": "Bearbeite dein Quiz",
            "submit_button": "Zur ?berpr?fung einreichen",
            "save_button": "Speicher?nderungen",
            "hint": "Ihr Quiz wird ?berpr?ft, bevor es im Feed erscheint. Zuverl?ssige Mitwirkende werden sofort ver?ffentlicht. ",
            "success_updated": "Inhalte werden erfolgreich aktualisiert",
            "success_published": "Inhalte erfolgreich ver?ffentlicht",
            "success_submitted": "Inhalte, die zur ?berpr?fung eingereicht wurden",
            "success_created": "Erfolgreich erstellte Inhalte",
            "success_translation": "Erfolgreich erstellte ?bersetzung",
            "failed": "Ich habe es nicht geschafft, Inhalte zu {{action}}",
            "action_update": "Aktualisierung",
            "action_create": "Erschaffen",
            "choose_translation_language": "W?hle eine Sprache f?r die ?bersetzung. ",
            "admin_add": "Inhalt hinzuf?gen",
            "admin_edit": "Inhalt bearbeiten",
            "admin_add_translation": "?bersetzung hinzuf?gen",
            "admin_add_translation_lang": "F?gen Sie {{lang}} ?bersetzung hinzu",
            "admin_create": "Inhalte erstellen",
            "admin_update": "Inhalt aktualisieren",
            "admin_create_translation": "?bersetzung erstellen"
        }
    },
    "content_form": {
        "title": "Titel",
        "slug": "Slug",
        "language": "Sprache",
        "difficulty": "Schwierigkeit (1?5)",
        "country": "Land",
        "status": "Status",
        "visibility": "Sichtbarkeit",
        "categories": "Kategorien",
        "tags": "Tags",
        "translations": "?bersetzungen",
        "translation_new": "(neu)",
        "translate_hint": "?bersetze die Frage, die Optionen und die Erkl?rung. Metadaten (Schwierigkeitsgrad, Kategorien, Tags) werden aus der Quelle ?bernommen. ",
        "choose_language": "W?hle die Sprache",
        "not_set": "Nicht festgelegt",
        "description": "Beschreibung",
        "description_placeholder": "Frage- oder Aufgabenbeschreibung",
        "options": "Optionen",
        "option_n": "Option {{n}}",
        "add_option": "+ Option hinzuf?gen",
        "remove": "Entfernen",
        "correct_answer": "Richtige Antwort",
        "explanation": "Erkl?rung",
        "explanation_placeholder": "Optional ? angezeigt nach einer falschen Antwort"
    },
    "user_stats": {
        "title": "Deine Statistiken",
        "sign_in_prompt": "Melden Sie sich an, um Ihre Statistiken zu sehen",
        "guest_title": "Rang. Leveln Sie auf. Steigen Sie Ligen hoch. ",
        "guest_lead": "Verfolge XP, schalte Titelr?nge frei und k?mpfe in w?chentlichen Ligen, sobald du dich eingeloggt hast. ",
        "guest_perk_level": "Verdiene XP durch Quizze und steige durch Level auf. ",
        "guest_perk_rank": "Schalte Titelr?nge frei, wenn dein Level steigt. ",
        "guest_perk_league": "Tritt w?chentlichen Gruppen bei und bewerbe dich f?r Legend?r. ",
        "xp": "XP",
        "streak": "Serie",
        "best_streak": "Beste Serie",
        "solved": "Beantwortet",
        "correct": "Richtig",
        "accuracy": "Genauigkeit",
        "bookmarks": "Lesezeichen",
        "contribute": "Beitrag leisten",
        "likes": "Likes",
        "language_mastered": "Mastered",
        "language_learning": "Lernen",
        "last_7_days": "Letzte 7 Tage",
        "days_suffix": "d",
        "no_activity": "Noch keine Aktivit?t",
        "weekly_league": "W?chentliche Liga",
        "league_tiers": "Ligastufen",
        "league_tiers_hint": "Stufen vom niedrigsten bis zum h?chsten. F?hre deine Gruppe an, um aufzusteigen; Letzter degradiert. ",
        "league_position": "#{{position}} {{total}} diese Woche",
        "view_leaderboard": "Full Board",
        "how_leagues_work": "Wie es funktioniert",
        "you": "Du"
    },
    "gamification": {
        "level": "Level",
        "rank": "Rang",
        "streak": "Serie",
        "daily_goals": "Tagesziele",
        "achievements": "Erfolge",
        "leaderboard": "Bestenliste",
        "season": "Saison",
        "xp_to_next": "{{current}} / {{next}} XP auf das n?chste Level",
        "weekly": "W?chentlich",
        "monthly": "Diesen Monat",
        "overall": "Gesamtergebnis",
        "monthly_hint": "Bewertet Spieler nach gewerteten XP, die sie w?hrend der aktuellen Kalendermonatssaison verdient haben (gleiche abnehmende Ertr?ge wie bei w?chentlichen Ligen). Keine separate Ligastufe. ",
        "overall_hint": "Allzeit-Ranking nach permanenter Gesamt-XP. ",
        "overall_empty": "Noch keine Spieler auf dem Gesamtboard. ",
        "players": "Mitglieder",
        "full_board": "Full Board",
        "player": "Mitglied",
        "ranked_xp": "Ranglisten-XP",
        "total_xp": "Gesamt-XP",
        "standing": "Standing",
        "zone": "Standing",
        "zone_promotion": "Bef?rderung",
        "zone_safe": "Sicher",
        "zone_relegation": "Abstieg",
        "zone_legend": "Top {{promo}} aufsteigen ? Bottom {{releg}} am Wochenende absteigen. ",
        "unlocked": "Entsperrt",
        "achievements_error": "Erfolge wurden nicht geladen",
        "achievements_intro": "Schalte beim Spielen Abzeichen frei ? Aktivit?t, Genauigkeit, Streaks, Schwierigkeit und das Lernen aus Fehlern. ",
        "achievement_categories": {
            "activity": "T?tigkeit",
            "correct_answers": "Richtige Antworten",
            "learning_from_mistakes": "Aus Fehlern lernen",
            "streaks": "Serien",
            "difficulty": "Schwierigkeit",
            "variety": "Vielfalt",
            "general": "Allgemeines"
        },
        "achievement_category_hints": {
            "learning_from_mistakes": "Nach einer falschen Antwort kann das Quiz sp?ter zur ?berpr?fung zur?ckkommen. Richtig zu beantworten z?hlt dann hier. "
        },
        "your_rank": "Dein Rang",
        "around_you": "Um dich herum",
        "tooltip_total_xp": "{{xp}} Gesamterfahrung",
        "tooltip_level": "Level {{level}}",
        "weekly_waiting": "Deine w?chentliche Gruppe kann nicht geladen werden. Bitte versuchen Sie es erneut. ",
        "weekly_ineligible": "Spiel weiter, um w?chentliche Ligen freizuschalten. ",
        "achievements_progress": "{{unlocked}} / {{total}} freigeschaltet",
        "toast": {
            "xp_gained": "+{{xp}} XP",
            "achievement": "Freigeschaltete Erfolge: {{name}}"
        },
        "level_up": {
            "title": "Level hoch! ",
            "body": "Du hast Level {{level}} erreicht",
            "continue": "Mach weiter"
        }
    },
    "creator": {
        "rank": "Sch?pferrang",
        "xp": "Sch?pfer-XP",
        "tooltip_rank": "{{rank}}",
        "tooltip_cxp": "{{xp}} CXP",
        "approved": "Genehmigte Beitr?ge",
        "views": "Ansichten",
        "completions": "Komplettierungen",
        "likes": "Likes",
        "bookmarks": "Lesezeichen",
        "top_contribution": "Top-Beitrag",
        "newest_contribution": "Neuester Beitrag",
        "to_next": "Zum n?chsten Rang",
        "players_board": "Mitglieder",
        "creators_board": "Mitwirkende",
        "board_group": "Bretttyp",
        "weekly": "W?chentlich",
        "monthly": "Monatlich",
        "all_time": "Allzeit-Zeiten",
        "weekly_hint": "Sch?pfer, die nach Creator-XP bewertet wurden, wurden diese Woche verdient. ",
        "monthly_hint": "Creator, die nach Creator-XP gerankt wurden, wurden diesen Monat verdient. ",
        "all_time_hint": "Allzeit-Rangliste nach Creator XP. ",
        "empty": "Noch keine Creator im Board. "
    },
    "profile": {
        "title": "Mein Profil",
        "edit": {
            "title": "Profil bearbeiten"
        },
        "nav": {
            "label": "Konto",
            "overview": "?berblick",
            "stats": "Statistiken",
            "leagues": "Ligen",
            "edit": "Profil bearbeiten",
            "contribute": "Beitrag leisten",
            "bookmarks": "Lesezeichen",
            "achievements": "Erfolge",
            "leaderboards": "Bestenlisten",
            "browse": "Durchst?bern Sie Inhalte"
        },
        "actions": {
            "back_to_home": "Zur?ck nach Hause",
            "back_to_profile": "Zur?ck zum Profil",
            "edit": "Profil bearbeiten",
            "contribute": "Beitrag leisten"
        },
        "labels": {
            "initials": "Initialen",
            "role": "Rolle",
            "status": "Status",
            "sign_in_method": "Anmeldemethode",
            "member_since": "Mitglied seit",
            "country": "Land",
            "reliable": "Zuverl?ssiger Mitwirkender"
        },
        "sections": {
            "account_info": "Kontoinformationen",
            "authentication": "Authentifizierung",
            "creator": "Sch?pfer",
            "stats": "Deine Werte",
            "leagues": "W?chentliche Ligen"
        },
        "stats": {
            "title": "Statistiken",
            "subtitle": "Dein Fortschritt, deine Aktivit?t und deine w?chentliche Liga auf einen Blick. ",
            "empty": "Noch keine Statistiken. Spiel ein paar Quizze, um loszulegen. ",
            "periods": "Heute und diese Woche",
            "today": "Heute",
            "see_all": "Alle Statistiken",
            "see_leagues": "Offene Ligen-Seite"
        },
        "leagues": {
            "title": "Ligen",
            "subtitle": "Ihre w?chentliche Ligaklasse, Gruppenplatzierung und Aufstiegs- oder Abstiegszone. ",
            "your_group": "Deine Gruppe diese Woche",
            "see_all": "Offene Ligen"
        }
    },
    "notifications": {
        "title": "Benachrichtigungen",
        "hint": "Erhalten Sie Benachrichtigungen ?ber Ihre Serie, Ligaposition und Ihre Inhalte ? auch wenn Procrastiq geschlossen ist. ",
        "enable": "Benachrichtigungen aktivieren",
        "disable": "Deaktivieren auf diesem Ger?t",
        "enabled": "Benachrichtigungen aktiviert",
        "disabled": "Benachrichtigungen auf diesem Ger?t deaktiviert",
        "enable_failed": "Benachrichtigungen konnten nicht aktiviert werden",
        "disable_failed": "Benachrichtigungen konnten nicht deaktiviert werden",
        "prefs_failed": "Pr?ferenzen konnten nicht gespeichert werden",
        "unsupported": "Push-Benachrichtigungen werden in diesem Browser nicht unterst?tzt. ",
        "pref_ranking": "Liga und Rangliste",
        "pref_streak": "Serie",
        "pref_reactions": "Reaktionen auf meine Inhalte",
        "pref_approved": "Inhaltsfreigabe"
    },
    "games": {
        "challenge_friend": "Challenge a friend",
        "survival_mode": "Survival",
        "challenges_inbox": "Challenges",
        "view_inbox": "View inbox",
        "pick_friend": "Pick a friend",
        "random_opponent": "Random opponent",
        "search_users": "Search by name?",
        "search_error": "Could not search users",
        "selected": "Selected",
        "selected_opponent": "Selected player",
        "pick_opponent": "Pick an opponent first",
        "random_hint": "We'll match you with an active player.",
        "any_category": "Any category",
        "category_optional": "Category (optional)",
        "start_challenge": "Send challenge",
        "challenge_created": "Challenge sent!",
        "create_error": "Could not create challenge",
        "challenge": "Challenge",
        "open": "Open",
        "new_challenge": "New challenge",
        "start_playing": "Start playing",
        "accept_play": "Accept & play",
        "decline": "Decline",
        "decline_error": "Could not decline challenge",
        "your_result": "Your result",
        "opponent_result": "Opponent",
        "waiting_opponent": "Waiting for your opponent to finish?",
        "score_line": "{{correct}}/{{total}} correct ? {{time}}",
        "you_won": "You won!",
        "you_lost": "You lost",
        "draw": "It's a draw",
        "submitting": "Submitting answers?",
        "submit_error": "Could not submit challenge",
        "load_error": "Could not load",
        "not_found": "Challenge not found",
        "no_challenges": "No challenges yet",
        "incoming": "Incoming",
        "outgoing": "Outgoing",
        "player": "Player",
        "filter": {
            "incoming": "Incoming",
            "outgoing": "Outgoing",
            "all": "All"
        },
        "status": {
            "pending": "Pending",
            "in_progress": "In progress",
            "completed": "Completed",
            "declined": "Declined",
            "expired": "Expired"
        },
        "question_progress": "Question {{current}} / {{total}}",
        "time_left": "{{seconds}}s",
        "elapsed_time": "Time {{time}}",
        "overall_time": "Total time",
        "total_time_left": "Total {{seconds}}s",
        "no_options": "No answer options for this question",
        "survival_leaderboard": "Survival leaderboard",
        "survival_leaderboard_hint": "Best survival run per player in the selected period.",
        "survival_empty": "No survival scores yet ? be the first!",
        "play_survival": "Play Survival",
        "current_score": "Score: {{score}}",
        "game_over": "Game over",
        "final_score": "You scored {{score}}",
        "personal_best": "Personal best: {{score}}",
        "daily_rank": "Daily rank: #{{rank}}",
        "weekly_rank": "Weekly rank: #{{rank}}",
        "play_again": "Play again",
        "survival_start_error": "Could not start survival run",
        "survival_error": "Survival error",
        "daily": "Daily",
        "weekly": "Weekly",
        "all_time": "All time",
        "score": "Score",
        "challenge_user": "Challenge {{name}}",
        "login_to_challenge": "Log in to challenge this player",
        "profile_error": "Could not load profile",
        "profile_not_found": "Player not found",
        "profile": "Profile",
        "notifications": "Notifications",
        "mark_all_read": "Mark all read",
        "no_notifications": "No notifications",
        "blocked_users": "Blocked players",
        "blocked_hint": "Blocked players cannot challenge you.",
        "no_blocked": "You haven't blocked anyone.",
        "unblock": "Unblock",
        "unblocked": "Player unblocked",
        "unblock_error": "Could not unblock player",
        "blocked_load_error": "Could not load blocked players",
        "survival_howto": "Antworte so lange richtig wie möglich. Du hast 20 Sekunden pro Frage. Ein Fehler wird verziehen — der zweite beendet den Lauf. Deine Punktzahl ist die Anzahl richtiger Antworten.",
        "challenge_howto": "Zehn Fragen, jeweils 20 Sekunden. Mehr richtige Antworten und eine schnellere Zeit gewinnen. Das Ergebnis deines Gegners siehst du, wenn ihr beide fertig seid.",
        "continue": "Weiter",
        "survival_reserve": "Reserve: {{count}}",
        "survival_second_chance": "Zweite Chance!",
        "guest_teaser": "Log in to challenge friends and climb Survival ranks."
    }
};
